import { SET_LOCATIONS_DATA } from 'js/store/locations/Locations.actions.js';

import { parseData } from 'js/store/locations/Locations.parser.js';

const initState = {
  locationIds: [],
  locationsById: {},
};

const locations = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_LOCATIONS_DATA: {
      const { locationsById, locationIds } = parseData(action.payload);
      nextState.locationIds = locationIds;
      nextState.locationsById = locationsById;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default locations;
